<template>
  <q-page style="height: 100vh" class="col-12 flex content-center justify-center">
    {{ $t('loggedOut') }}
  </q-page>
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router';
import { useQuasar } from 'quasar';
import { useI18n } from 'vue-i18n';

const $q = useQuasar();
const { t } = useI18n();

const router = useRouter();

$q.notify({
  color: 'green-4',
  icon: 'mdi-check-circle',
  message: t('successful.logout')
});

setTimeout(() => {
  router.push({ name: 'login' }).catch(() => {
      $q.notify({
        color: 'error-4',
        icon: 'mdi-alert-circle',
        message: t('error.route')
      });
    }
  );
}, 2500);
</script>
